import GdsModel from '~/glm/models/gds/gds-model';
import { computed, action, observable } from 'mobx';
import get from 'lodash/get';

export default class GdsInvitationModel extends GdsModel {
  id;
  eventId;
  guestId;
  householdID;
  @observable rsvp;
  @observable meal;
  @observable gift;
  @observable invitationSent;
  @observable thankYouSent;
  @observable answers;

  constructor(invitation = {}, householdID = '', guestId = '') {
    super();
    this.id = invitation.id || undefined;
    this.eventId = invitation.eventId;
    this.rsvp = invitation.rsvp;
    this.invitationSent = invitation.invitationSent;
    this.thankYouSent = invitation.thankYouSent;
    this.meal = invitation.meal;
    this.householdID = householdID;
    this.guestId = guestId;
    this.gift = invitation.gift;
    this.answers = invitation.answers || [];
  }

  @computed
  get apiEndpoint() {
    return `/v1/households/${this.householdID}/people/${this.guestId}/invitations${this.id ? `/${this.id}` : ''}`;
  }

  @computed
  get displayRsvp() {
    if (this.rsvp === true) {
      return 'Attending';
    } else if (this.rsvp === false) {
      return 'Declined';
    }

    return 'Invited';
  }

  @computed
  get displayMeal() {
    return this.meal || 'No Response';
  }

  @computed
  get displayMealIAVersion() {
    return this.meal || 'No Reply';
  }

  @computed
  get apiParams() {
    const { id, eventId, rsvp, gift, thankYouSent, answers } = this;
    return { id, eventId, rsvp, gift, thankYouSent, answers };
  }

  @action
  getMealAnswer(question) {
    if (!question) return null;
    const mealAnswer = this.answers.find(answer => answer.questionId === question.id);

    if (!mealAnswer) return 'No Reply';
    const chosenMeal = question.options.find(option => option.id === mealAnswer.optionId);

    return get(chosenMeal, ['text']);
  }

  @action
  removeAnswer(questionId) {
    this.answers = this.answers.filter(answer => answer.questionId !== questionId);
  }

  @action
  updateAnswer(questionId, newAnswer) {
    this.answers = this.answers.map(answer => (answer.questionId === questionId ? newAnswer : answer));
  }

  @action
  addAnswer(answer) {
    this.answers.push(answer);
  }

  @action
  updateInvite(invitationJson) {
    this.id = invitationJson.id;
    this.rsvp = invitationJson.rsvp;
    this.invitationSent = invitationJson.invitationSent;
    this.meal = invitationJson.meal;
    this.thankYouSent = invitationJson.thankYouSent;
    this.gift = invitationJson.gift;
    this.answers = invitationJson.answers ? invitationJson.answers : [];
  }
}
